import React from 'react';
import { isEmpty, map } from 'lodash';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/auth-member-search';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { button as Button } from 'modules/button';
import * as ROUTE_PATHS from 'constants/route-paths';
import { TABLE_TEMPLATE_TYPE } from 'constants/common';

/*******************************/

// success view
export const authFlowCallerIdentificationMemberSuccess = ( props ) => {

    // dynamic class name
    const widgetClassName = classnames( 'ui-auth-flow-caller-identification-member', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchWidget
                className='ui-auth-flow-caller-identification-member__table-search'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                requestPayload= { props.requestPayload }
                persistTableData={ true }
                templateType = { TABLE_TEMPLATE_TYPE.ADVANCED_SEARCH }
            />

            {/* navigation actions */}
            {
                isEmpty( props.componentData.navActions ) ? null : (
                    <div className='ui-auth-flow-caller-identification-member__navigation'>
                        {
                            map( props.componentData.navActions, navAction => {

                                // if `cancel` action, redirect to dashboard
                                if( 'cancel' === navAction.name && isEmpty( props.callState ) ) {
                                    return (
                                        <Button
                                            key={ navAction.name }
                                            title={ navAction.title }
                                            size='large'
                                            outline={ true }
                                            onClick={ () => props.history.replace( ROUTE_PATHS.DASHBOARD ) }
                                        />
                                    );
                                }

                                // return `null` view
                                return null;
                            } )
                        }
                    </div>
                )
            }
        </div>
    );
};

// set display name
authFlowCallerIdentificationMemberSuccess.displayName = 'authFlowCallerIdentificationMemberSuccess';

// set default props
authFlowCallerIdentificationMemberSuccess.defaultProps = {
    componentData: {},
};

// prop types
authFlowCallerIdentificationMemberSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowCallerIdentificationMemberPreloader = () => {
    return (
        <div className='ui-auth-flow-caller-identification-member-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
authFlowCallerIdentificationMemberPreloader.displayName = 'authFlowCallerIdentificationMemberPreloader';

// set default props
authFlowCallerIdentificationMemberPreloader.defaultProps = {};

// prop types
authFlowCallerIdentificationMemberPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowCallerIdentificationMember as AuthFlowCallerIdentificationMember } from 'ui/views/widgets/authFlowCallerIdentificationMember';
 *
 * // render
 * <AuthFlowCallerIdentificationMember propName='propValue'/>
 */
export const authFlowCallerIdentificationMember = withNetworkState( authFlowCallerIdentificationMemberPreloader, withRouter( authFlowCallerIdentificationMemberSuccess ) );
